import type { U3204MessageSource } from '../U3204Service';

/** Libellé d’un lien Sources (BL-0200 product / BL-0219 org). */
export function u3204MessageSourceLinkLabel(source: U3204MessageSource): string {
  if (source.kind === 'org') {
    return source.displayName ?? (source.sectionTitle || source.sectionPath);
  }
  return `${source.logicalUnitCode} — ${source.sectionTitle}`;
}
